@if (step == 1) {
  <div class="bloc-content-body">
    <p class="current-step">Adresse de facturation</p>
    @if (form) {
      <form class="form w-100" [formGroup]="form" (ngSubmit)="submit()">
        <div class="bloc-input">
          <label for="address">Adresse<sup>*</sup></label>
          <input
            type="text"
            id="address"
            name="address"
            formControlName="address"
            placeholder="Votre adresse"
            required
            />
          @if (formSubmitted && getError('address')) {
            <small class="error-message">
              {{ getError('address') }}
            </small>
          }
        </div>
        <div class="bloc-input">
          <label for="addressComplement">Complément d'adresse</label>
          <input
            type="text"
            id="addressComplement"
            name="addressComplement"
            formControlName="addressComplement"
            placeholder="Votre complément d'adresse "
            />
          @if (formSubmitted && getError('addressComplement')) {
            <small class="error-message">
              {{ getError('addressComplement') }}
            </small>
          }
        </div>
        <div class="bloc-input">
          <label for="zipCode">Code postal<sup>*</sup></label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            formControlName="zipCode"
            placeholder="Votre code postal"
            required
            />
          @if (formSubmitted && getError('zipCode')) {
            <small class="error-message">
              {{ getError('zipCode') }}
            </small>
          }
        </div>
        <div class="bloc-input">
          <label for="city">Ville<sup>*</sup></label>
          <input
            type="text"
            id="city"
            name="city"
            formControlName="city"
            placeholder="Votre ville"
            required
            />
          @if (formSubmitted && getError('city')) {
            <small class="error-message">
              {{ getError('city') }}
            </small>
          }
        </div>
        <div class="bloc-input">
          <label for="sameAddress" class="box-grid">
            <input class="checkbox" type="checkbox" id="sameAddress" (click)="setSameAddress($event)"/>
            L'adresse de livraison est la même que l'adresse de facturation
          </label>
        </div>
        <div class="row w-100 pt-3 text-center">
          <div class="col-12 w-100 cta_container">
            <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
          </div>
        </div>
      </form>
    }
  </div>
}
@if (step == 2) {
  <div>
    <app-account-shipping-address (accountShippingAddress)="setAccountShippingAddress($event)"></app-account-shipping-address>
  </div>
}

